import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiResponse, PaginatedApiResponse } from '@card-software/library';
import { RemissionGuideDto, RemissionGuideStatus } from '../models/remission-guide/remission-guide';
import { RemissionGuideSearchCommand } from '../models/remission-guide/remission-guide-search';

@Injectable({
  providedIn: 'root',
})
export class RemissionGuideProxyService {
  private readonly baseUrl = environment.proxyUrls.inventoryApi + '/api/v1/remission-guide';

  constructor(private http: HttpClient) {}

  public getById(id: string): Observable<ApiResponse<RemissionGuideDto>> {
    return this.http.get<ApiResponse<RemissionGuideDto>>(`${this.baseUrl}/${id}`);
  }

  public search(
    command: RemissionGuideSearchCommand,
    pageNumber = 1,
    pageSize = 25,
    sortField?: string,
    sortOrder = -1,
  ): Observable<ApiResponse<PaginatedApiResponse<RemissionGuideDto>>> {
    let url = `${this.baseUrl}/search?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (sortField) {
      url += `&sortField=${encodeURIComponent(sortField)}&sortOrder=${sortOrder}`;
    }
    return this.http.post<ApiResponse<PaginatedApiResponse<RemissionGuideDto>>>(url, command);
  }

  public create(body: Partial<RemissionGuideDto>): Observable<ApiResponse<RemissionGuideDto>> {
    return this.http.post<ApiResponse<RemissionGuideDto>>(`${this.baseUrl}`, body);
  }

  public update(id: string, body: Partial<RemissionGuideDto>): Observable<ApiResponse<RemissionGuideDto>> {
    return this.http.put<ApiResponse<RemissionGuideDto>>(`${this.baseUrl}/${id}`, body);
  }

  public updateStatus(id: string, newStatus: RemissionGuideStatus): Observable<ApiResponse<RemissionGuideDto>> {
    return this.http.put<ApiResponse<RemissionGuideDto>>(`${this.baseUrl}/status/${id}`, newStatus);
  }

  public delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
}
